<script lang="ts">
	import activeLocale from 'stores/activeLocale';
	import { get } from 'svelte/store';


	export let href;

	let currentLocale = get(activeLocale);

	const setLocaleData = () => (currentLocale = get(activeLocale));

	$: $activeLocale, setLocaleData();

	$: localeHref = currentLocale.locale === 'en' ? `${href}` : href !== '/' ? `${href}/${currentLocale.locale}` : `/${currentLocale.locale}` ;
</script>

<a href={localeHref} class={$$props.class} aria-label={$$props.label || ''} on:click={$$props.handler}>
	<slot />
</a>
